import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function AvatarWithTitle(_ref) {
  let {
    avatarSrc,
    avatarAlt,
    title,
    dataTestId
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    className: "flex items-center",
    children: [/*#__PURE__*/_jsx("img", {
      className: "w-10 h-10 rounded-full mr-4 my-auto",
      src: avatarSrc,
      alt: avatarAlt !== null && avatarAlt !== void 0 ? avatarAlt : "avatar image",
      "data-testid": dataTestId === null || dataTestId === void 0 ? void 0 : dataTestId.avatar
    }), /*#__PURE__*/_jsx("div", {
      className: "text-lg lg:text-4xl",
      "data-testid": dataTestId === null || dataTestId === void 0 ? void 0 : dataTestId.title,
      title: title,
      children: title
    })]
  });
}